import { TakeoverData } from '@/app/util/searchbar-takeover'
import { createContext } from 'react'

export const AdProductContext = createContext({
    takeover: undefined as TakeoverData | undefined,
})
